import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { track } from 'modules/core/lib/Tracking'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import AnonymousBlankSlate from 'modules/surveys/components/Analytics/AnonymousBlankSlate'
import BlankSlate from 'modules/surveys/components/Analytics/_BlankSlate'
import FilteredBlankSlate from 'modules/surveys/components/Analytics/_FilterBlankSlate'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import { useAnalytics } from 'modules/surveys/pages/Show/hooks'
import { Question } from 'modules/surveys/store/models/AnalyticResult'

import Table from './_List'
import Rating from './_Rating'
import SingleChoice from './_SingleChoice'

interface Props {
  isFilterApplied: boolean
}

const ScoreResults = ({ isFilterApplied }: Props) => {
  const { analyticResult } = useAnalytics()
  const { isAnonymous } = useSurveyShowContext()

  track('Survey analytics view')

  if (!analyticResult) {
    if (isAnonymous) return <AnonymousBlankSlate />
    if (isFilterApplied) return <FilteredBlankSlate />
    return <BlankSlate />
  }

  const questionsList: Question[] = Array.from(analyticResult?.questions)

  return (
    <Box gap="s32" overflowY="auto">
      {questionsList.map((question: Question) => {
        const { type } = question

        switch (type) {
          case FieldTypes.text:
          case FieldTypes.cents:
            return <Table question={question} key={question.id} />

          case FieldTypes.rating:
            return <Rating question={question} key={question.id} />

          case FieldTypes.singleChoice:
            return <SingleChoice question={question} key={question.id} />

          default:
            throw new Error(`Unsupported field type ${type} in surveys score results`)
        }
      })}
    </Box>
  )
}

export default observer(ScoreResults)
